import revive_payload_client_4sVQNw7RlN from "/usr/src/app/node_modules/nuxt/dist/app/plugins/revive-payload.client.js";
import unhead_KgADcZ0jPj from "/usr/src/app/node_modules/nuxt/dist/head/runtime/plugins/unhead.js";
import router_jmwsqit4Rs from "/usr/src/app/node_modules/nuxt/dist/pages/runtime/plugins/router.js";
import _0_siteConfig_MwZUzHrRNP from "/usr/src/app/node_modules/nuxt-site-config/dist/runtime/nuxt/plugins/0.siteConfig.js";
import payload_client_yVLowv6hDl from "/usr/src/app/node_modules/nuxt/dist/app/plugins/payload.client.js";
import navigation_repaint_client_bs2bWDGRIE from "/usr/src/app/node_modules/nuxt/dist/app/plugins/navigation-repaint.client.js";
import check_outdated_build_client_8vK7RkfGxZ from "/usr/src/app/node_modules/nuxt/dist/app/plugins/check-outdated-build.client.js";
import chunk_reload_client_UciE0i6zes from "/usr/src/app/node_modules/nuxt/dist/app/plugins/chunk-reload.client.js";
import plugin_vue3_YdLad5Mpq3 from "/usr/src/app/node_modules/@pinia/nuxt/dist/runtime/plugin.vue3.js";
import components_plugin_KR1HBZs4kY from "/usr/src/app/.nuxt/components.plugin.mjs";
import prefetch_client_5tzzN0oIVL from "/usr/src/app/node_modules/nuxt/dist/pages/runtime/plugins/prefetch.client.js";
import plugin_client_xSLIPjreZL from "/usr/src/app/node_modules/nuxt-meta-pixel/dist/runtime/plugin.client.mjs";
import plugin_tbFNToZNim from "/usr/src/app/node_modules/@zadigetvoltaire/nuxt-gtm/dist/runtime/plugin.mjs";
import plugin_client_UYiXMU8ZyN from "/usr/src/app/node_modules/nuxt-gtag/dist/runtime/plugin.client.js";
import titles_dw2T9lEw4h from "/usr/src/app/node_modules/@nuxtjs/seo/dist/runtime/nuxt/plugin/titles.js";
import defaults_aRl2YLnTcb from "/usr/src/app/node_modules/@nuxtjs/seo/dist/runtime/nuxt/plugin/defaults.js";
import siteConfig_izaWKZ8rEu from "/usr/src/app/node_modules/nuxt-seo-experiments/dist/runtime/nuxt/plugins/siteConfig.js";
import inferSeoMetaPlugin_Uk9bcXDHeN from "/usr/src/app/node_modules/nuxt-seo-experiments/dist/runtime/nuxt/plugins/inferSeoMetaPlugin.js";
import floating_vue_EIcJ7xiw0h from "/usr/src/app/.nuxt/floating-vue.mjs";
import plugin_BqLkNUef68 from "/usr/src/app/node_modules/@nuxtjs/algolia/dist/runtime/plugin.mjs";
import switch_locale_path_ssr_8BKffvaEi5 from "/usr/src/app/node_modules/@nuxtjs/i18n/dist/runtime/plugins/switch-locale-path-ssr.mjs";
import i18n_yfWm7jX06p from "/usr/src/app/node_modules/@nuxtjs/i18n/dist/runtime/plugins/i18n.mjs";
import nuxt_plugin_6wEQMY3tee from "/usr/src/app/node_modules/nuxt-delay-hydration/dist/runtime/nuxt-plugin.js";
import plugin_AUP22rrBAc from "/usr/src/app/node_modules/@pinia-plugin-persistedstate/nuxt/dist/runtime/plugin.js";
import api_client_hHF76B0Hrp from "/usr/src/app/plugins/api.client.ts";
import handle_errors_client_Cfn5ijGvG0 from "/usr/src/app/plugins/handle-errors.client.ts";
import pinia_sync_client_JZSgIkPWoL from "/usr/src/app/plugins/pinia-sync.client.ts";
import sentry_client_shVUlIjFLk from "/usr/src/app/plugins/sentry.client.ts";
import serverApi_4xl2Pl6WP5 from "/usr/src/app/plugins/serverApi.ts";
import toastify_client_zzPWHgjcj4 from "/usr/src/app/plugins/toastify.client.ts";
import plugin_client_QHzhVBB2Ll from "/usr/src/app/.nuxt/nuxt-booster/plugin.client.js";
export default [
  revive_payload_client_4sVQNw7RlN,
  unhead_KgADcZ0jPj,
  router_jmwsqit4Rs,
  _0_siteConfig_MwZUzHrRNP,
  payload_client_yVLowv6hDl,
  navigation_repaint_client_bs2bWDGRIE,
  check_outdated_build_client_8vK7RkfGxZ,
  chunk_reload_client_UciE0i6zes,
  plugin_vue3_YdLad5Mpq3,
  components_plugin_KR1HBZs4kY,
  prefetch_client_5tzzN0oIVL,
  plugin_client_xSLIPjreZL,
  plugin_tbFNToZNim,
  plugin_client_UYiXMU8ZyN,
  titles_dw2T9lEw4h,
  defaults_aRl2YLnTcb,
  siteConfig_izaWKZ8rEu,
  inferSeoMetaPlugin_Uk9bcXDHeN,
  floating_vue_EIcJ7xiw0h,
  plugin_BqLkNUef68,
  switch_locale_path_ssr_8BKffvaEi5,
  i18n_yfWm7jX06p,
  nuxt_plugin_6wEQMY3tee,
  plugin_AUP22rrBAc,
  api_client_hHF76B0Hrp,
  handle_errors_client_Cfn5ijGvG0,
  pinia_sync_client_JZSgIkPWoL,
  sentry_client_shVUlIjFLk,
  serverApi_4xl2Pl6WP5,
  toastify_client_zzPWHgjcj4,
  plugin_client_QHzhVBB2Ll
]